import { render, staticRenderFns } from "./DocumentsWidget.vue?vue&type=template&id=25d2adc8&"
import script from "./DocumentsWidget.vue?vue&type=script&lang=ts&"
export * from "./DocumentsWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports